import React from "react";
import { useTranslation } from "react-i18next";
import IconBall from "../../img/IconBall";
import {
  StyledMenu,
  ContainerScroll,
  ContainerHead,
  TextProode,
  Button,
  ContainerIcon,
  ContainerModal,
} from "./styled";
import { Sling as Hamburger } from "hamburger-react";

const Menu = ({ openMenu, setOpenMenu }) => {
  const [t] = useTranslation("global");
  const Close = () => {
    setOpenMenu(false);
  };

  return (
    <StyledMenu openMenu={openMenu}>
      <ContainerHead>
        <TextProode>PROODE MUNDIAL</TextProode>
        <Button onClick={() => setOpenMenu(!openMenu)}>
          <Hamburger
            toggled={openMenu}
            toggle={setOpenMenu}
            color="#a71b38"
            size={20}
          />
        </Button>
      </ContainerHead>
      <ContainerScroll>
        <ContainerIcon>
          <IconBall />
          <a onClick={Close} href="#feature">
            {t("features.features")}
          </a>
        </ContainerIcon>

        <ContainerIcon>
          {" "}
          <IconBall />
          <a onClick={Close} href="#business">
            {t("business.business")}{" "}
          </a>
        </ContainerIcon>
        <ContainerIcon>
          <IconBall />{" "}
          <a onClick={Close} href="#contact">
            {" "}
            {t("contact.contact")}
          </a>
        </ContainerIcon>
        <ContainerModal>
          <p>PROODE MUNDIAL {t("product.product")}</p>
          <p>
            {t("de.de")}&nbsp;
            <a href="https://crombie.dev/work/proode" target="blank">
              Crombie.dev
            </a>
          </p>
        </ContainerModal>
      </ContainerScroll>
    </StyledMenu>
  );
};

export default Menu;
